import { ECGPackageType } from 'features/vital';

export enum VitalSensors {
  BLOOD_PRESSURE = 'blood_pressure',
  BLOOD_OXY = 'blood_oxy',
  TEMPERATURE = 'temperature',
  GLUCOSE = 'glucose',
  ECG = 'ECG',
  MANUAL_WEIGHT = 'manual_weight',
  MANUAL_HEIGHT = 'manual_height',
  MANUAL_PEAK_FLOW = 'manual_peak_flow',
  MANUAL_NOTES = 'manual_notes',
}

export type BloodPressureType = {
  Sys: number;
  Dia: number;
  Plus: number;
};

export type BloodOxyType = {
  SpO2: number;
  PR: number;
};

type SingleValueType = {
  Value: number;
};

export type TemperatureType = SingleValueType;

export type GlucoseType = SingleValueType;

export type ManualValueType = {
  Value: number;
  Unit: string;
  LastUpdate?: string;
};

export type ManualNotesType = {
  VisitReason: string;
  GeneralNotes: string;
  LastUpdate?: string;
};

export type VitalMessage = {
  typeString: string;
  data: unknown;
  timestamp?: number;
};

export type VitalsDataPayload = {
  status?: 'connected' | 'pending' | 'disconnected';
  bloodPressure?: BloodPressureType;
  bloodOxy?: BloodOxyType;
  temperature?: TemperatureType;
  glucose?: GlucoseType;
  manualWeight?: ManualValueType;
  manualHeight?: ManualValueType;
  manualPeakFlow?: ManualValueType;
  manualNotes?: ManualNotesType;
};
